import { newRequest, oldRequest } from "./complexRequest"
import { ComplexRequestOption, PageQueryFn, PageResponse, ResponseType } from "./type"

// 创建人设
export const createPersonal = async (
  data?: any,
  option?: ComplexRequestOption,
  useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/UserCharacter/createCharacter',
    data,
    method: 'post',
    ...option
  }, useFetch)
}


// 获取机器人列表
export const getPersonaList: PageQueryFn<any> = async (data, option = {}, useFetch = true) => {
  return oldRequest<PageResponse>({
    url: '/Api/UserCharacter/index',
    data,
    ...option
  }, useFetch)
}


// 删除人设
export const deletePersona = async (
  data?: { character_id: number },
  option?: ComplexRequestOption,
  useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/UserCharacter/deleteCharacter',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 创建人设
export const updatePersonal = async (
  data?: any,
  option?: ComplexRequestOption,
  useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/UserCharacter/updateCharacter',
    data,
    method: 'post',
    ...option
  }, useFetch)
}


// 获取人设通过Id
export const getPersonaById = async (
  data?: { character_id: number },
  option?: ComplexRequestOption,
  useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/UserCharacter/detailCharacter',
    data,
    method: 'post',
    ...option
  }, useFetch)
}